var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      ref: "tablaRecaudadores",
      attrs: {
        stripe: "",
        search: "",
        "max-items": _vm.maximoItems == "" ? 1 : _vm.maximoItems,
        data: _vm.registros,
        pagination: ""
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(tr, indextr) {
              return _c(
                "vs-tr",
                { key: indextr },
                [
                  _c("vs-td", [
                    _c(
                      "label",
                      {
                        attrs: {
                          for: "seleccionado_" + data[indextr].recaudador_id
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: data[indextr].cerrado,
                              expression: "data[indextr].cerrado"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            id: "seleccionado_" + data[indextr].recaudador_id,
                            disabled: !_vm.puedeCerrar
                          },
                          domProps: {
                            checked: Array.isArray(data[indextr].cerrado)
                              ? _vm._i(data[indextr].cerrado, null) > -1
                              : data[indextr].cerrado
                          },
                          on: {
                            change: function($event) {
                              var $$a = data[indextr].cerrado,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      data[indextr],
                                      "cerrado",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      data[indextr],
                                      "cerrado",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(data[indextr], "cerrado", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(" ")])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("vs-td", [
                    _vm._v(_vm._s(data[indextr].recaudador_nombre))
                  ]),
                  _vm._v(" "),
                  _vm._l(data[indextr].detalles, function(row, indexD) {
                    return _c(
                      "vs-td",
                      { key: data[indextr].detalles[indexD].rubro_id },
                      [
                        _vm.editarFila
                          ? _c("input-field", {
                              attrs: {
                                vMoney: "",
                                format: _vm.decimal,
                                id:
                                  "valor_" +
                                  data[indextr].detalles[indexD].rubro_id,
                                readonly: data[indextr].cerrado
                              },
                              model: {
                                value: data[indextr].detalles[indexD].valor,
                                callback: function($$v) {
                                  _vm.$set(
                                    data[indextr].detalles[indexD],
                                    "valor",
                                    $$v
                                  )
                                },
                                expression:
                                  "data[indextr].detalles[indexD].valor"
                              }
                            })
                          : _c(
                              "button",
                              {
                                staticClass: "btn-secondary btn--text",
                                on: { click: _vm.mostrarFila }
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      data[indextr].detalles[indexD].valor == ""
                                        ? "-"
                                        : data[indextr].detalles[indexD].valor
                                    ) +
                                    "\n        "
                                )
                              ]
                            )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            })
          }
        }
      ])
    },
    [
      _c("template", { slot: "header" }, [
        _c(
          "div",
          { staticClass: "form-inline" },
          [
            _c("h3", [_vm._v("Registros consultados")]),
            _vm._v(" "),
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "###",
                    expression: "'###'"
                  }
                ],
                staticClass: "input-field--stretch ml-3",
                attrs: { type: "tel", id: "maximoItems", placeholder: "" },
                model: {
                  value: _vm.maximoItems,
                  callback: function($$v) {
                    _vm.maximoItems = $$v
                  },
                  expression: "maximoItems"
                }
              },
              [_c("span", [_vm._v("Cantidad de registros:")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Cerrado")]),
          _vm._v(" "),
          _c("vs-th", [_vm._v("Recaudador")]),
          _vm._v(" "),
          _vm._l(_vm.rubros, function(row, indexR) {
            return _c("vs-th", { key: _vm.rubros[indexR].rubro_id }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.rubros[indexR].rubro_descripcion +
                      (_vm.rubros[indexR].rubro_tipo == "I" ? " (+)" : " (-)")
                  ) +
                  "\n    "
              )
            ])
          })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8df1594", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8df1594","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/TablaIngresoRubros.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a8df1594","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/TablaIngresoRubros.vue
// module chunks = 0